import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, throwError } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class DataServiceDownloader {

    private static BASE_PATH = "https://data.eurovisionplayground.com/ds/v0/";

    constructor(private httpClient: HttpClient) {
        // DataServiceDownloader.BASE_PATH = 
    }

    public static setBasePathData(path: string) {
        DataServiceDownloader.BASE_PATH = path;
    }

    public static get NOT_FOUND(): string { return "404 NOT_FOUND"; }

    public downloadFile(path: string, receiver: (data: any) => void) {
        //MLLog.logDev("DataServiceDownloader.downloadFile", DataServiceDownloader.BASE_PATH);
        //MLLog.logDev("DataServiceDownloader.downloadFile", DataServiceDownloader.BASE_PATH + path);
        this.httpClient.get(DataServiceDownloader.BASE_PATH + path)
            .pipe(
                catchError(error => {
                    if (error.status === 404) {
                        //console.error("Recognized error 404");
                        receiver(DataServiceDownloader.NOT_FOUND);
                    } else {
                        console.error("Unknown Download error");
                    }
                    return "";
                })
            )
            .subscribe(
                (data) => {
                    receiver(data);
                }
            )
    }

}